import request from '@/libs/request'

export function getInfo(params) {
  return request({
    url: '/admin/robot/calculator_v1/bill', method: 'get', params
  })

}



// WEBPACK FOOTER //
// ./src/api/robot.js